import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search1",
  "use": "icon-search1-usage",
  "viewBox": "0 0 206.4 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 206.4 200\" id=\"icon-search1\">\n<path d=\"M163.3,89c0-41.5-33.5-75.2-74.8-75.2S13.7,47.5,13.7,89c0,41.6,33.5,75.2,74.8,75.2c21.4,0,41.4-9.1,55.5-24.7\n\tC156.4,125.6,163.3,107.6,163.3,89L163.3,89z M204.2,188c6.6,6.3-2.8,16.3-9.4,9.9L149,153.7c-16.3,15.6-38,24.3-60.6,24.3\n\tC39.6,178,0,138.1,0,89S39.6,0,88.4,0s88.4,39.8,88.4,89c0,19.8-6.5,39-18.6,54.6L204.2,188L204.2,188z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol